<template>
  <div>
    <h4>Настройки</h4>
    <label>
      <span>Выберите текст:</span>
      <v-select @input="onSelectText" 
                label="text" 
                :options="textsData" 
                v-model="params.text_id" 
                :reduce="option => option.id"
                :clearable="false">
        <template slot="option" slot-scope="option">
          <div class="d-center" v-html="option.html"></div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center"> {{ option.text }} </div>
        </template>
      </v-select> 
    </label>
    <div class="razd"></div>
    <label class="">
      <span>Время чтения</span>
      <input type="text" class="uk-input" v-model="params.countdownSeconds">
    </label>
  </div>
</template>

<script>
import { texts_settings_mixin } from '../../texts/texts_settings_mixin'
export default {
  name: "settings",
  mixins: [ texts_settings_mixin ],
  watch: {
    params: {
      handler: function (newValue) {
        if (!this.ingame) {
          this.$emit('params_changed', this.params);
        }
      },
      deep: true
    },
  },
  data() {
    return {
      params: {
        text_id: null,
      }
    }
  },
  props: {
    is_homework: ''
  },
  computed: {
    role() {
      return this.$store.state.user.role.code;
    },
  },
  mounted() {
    this.params = this.$store.state.train.speedtest_params;
  }
}
</script>